import BlogDetail from "parts/BlogDetail";
import Footer from "parts/Footer";
import Header from "parts/Header";
import React from "react";
import { Helmet } from "react-helmet-async";

const BlogDetailPage = () => {
  return (
    <>
      {/* SEO  */}
      <Helmet>
        <title>Blog Title Here | Scode Software Solutions</title>
        <meta
          name="description"
          content="Read this blog to learn about the latest in web development, mobile apps, and software solutions from Scode Software."
        />
        <link rel="canonical" href="https://www.scodesoft.com/blogs" />
      </Helmet>

      <Header />
      <BlogDetail />

      <Footer />
    </>
  );
};

export default BlogDetailPage;
